export function getFechaHoyMenos(menos = 30) {
    let d = new Date();
    d.setDate(d.getDate() - menos);
    return d.toJSON().slice(0, 10);
}

export function getFechaHoy() {
    let currentDate = new Date().toJSON().slice(0, 10);
    return currentDate;
}

export function getAnioActual() {
    return new Date().getFullYear() ;
}

export function getFechaInicioMesAnioActual(mes) {
    if (mes<10) {
        return getAnioActual()+"-0"+mes+"-01";
    } else {
        return getAnioActual()+"-"+mes+"-01";
    }
}

export function getFechaInicioAnioMes(anio, mes) {
    if (mes<10) {
        return anio+"-0"+mes+"-01";
    } else {
        return anio+"-"+mes+"-01";
    }
}

export function esBisiesto(year) {
    return (year % 400 === 0) ? true : 
                (year % 100 === 0) ? false : 
                    year % 4 === 0;
};

export function getFechaFinMesAnioActual(mes) {
    let dia = 31;
    if (mes==2) {
        dia = esBisiesto(getAnioActual())?29:28;
    } else if (mes==4 || mes==6 || mes==9 || mes==11) {
        dia = 30;
    }
    if (mes<10) {
        return getAnioActual()+"-0"+mes+"-"+dia;
    } else {
        return getAnioActual()+"-"+mes+"-"+dia;
    }
}

export function getFechaFinAnioMes(anio, mes) {
    let dia = 31;
    if (mes==2) {
        dia = esBisiesto(anio)?29:28;
    } else if (mes==4 || mes==6 || mes==9 || mes==11) {
        dia = 30;
    }
    if (mes<10) {
        return anio +"-0"+mes+"-"+dia;
    } else {
        return anio +"-"+mes+"-"+dia;
    }
}

export function getFechaInicioAnioActual() {
    return getAnioActual()+"-01-01";
}

export function getFechaInicioMes() {
    let fechaHoy = new Date();
    let mes = fechaHoy.getMonth()+1;
    if (mes<10) {
        return getAnioActual()+`-0${mes}-01`;
    } else {
        return getAnioActual()+`-${mes}-01`;
    }
}

export function getFechaInicioMesAnioAnterior() {
    let fechaHoyMenos365 = new Date();
    fechaHoyMenos365.setDate(fechaHoyMenos365.getDate() - 365);
    let anio = fechaHoyMenos365.getFullYear();
    let mes = fechaHoyMenos365.getMonth()+2;
    return anio+"-"+mes+"-01";
}

export function getMesFromNumero(num,resumido=true) {
    switch(num) {
        case 1:
            return resumido?"Ene":"Enero";
        case 2:
            return resumido?"Feb":"Febrero";
        case 3:
            return resumido?"Mar":"Marzo";
        case 4:
            return resumido?"Abr":"Abril";
        case 5:
            return resumido?"May":"Mayo";
        case 6:
            return resumido?"Jun":"junio";
        case 7:
            return resumido?"Jul":"Julio";
        case 8:
            return resumido?"Ago":"Agosto";
        case 9:
            return resumido?"Sep":"Septiembre";
        case 10:
            return resumido?"Oct":"Octubre";
        case 11:
            return resumido?"Nov":"Noviembre";
        case 12:
            return resumido?"Dic":"Diciembre";
    }
}